import axios from 'axios';

const physicaldevmid = {
    state: {  
		physicaldevmids : []
	},	
	mutations: {		
		physicaldevmids_success(state, payload){			
			state.physicaldevmids = payload	
		}	
	},
	actions: {
        getphysicaldevmid(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/Physicaldevelopmentmid/Getphysicaldevmid', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {						
					resolve(respdata)
				})
				.catch(err => {									
					reject(err)
				})
			})
		},			
		getphysicaldevmidbyid(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/Physicaldevelopmentmid/Getphysicaldevmidbyid', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {									
					reject(err)
				})
			})
		},						
		physicaldevmidregistration(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/Physicaldevelopmentmid/Registerphysicaldevmid', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {
					reject(err)
				})
			})
        },        
	}
}

export default physicaldevmid